import Vue from 'vue';
import Vuex from 'vuex';

import mutations from '@/store/global/mutations';
import actions from '@/store/global/actions';

import basket from './modules/basket/index';
import filters from './modules/filters/index';
import models from './modules/models/index';
import options from './modules/options/index';
import user from './modules/user/index';
import common from './modules/common/index';
import slider from './modules/slider/index';
import guide from './modules/guide/index';
import account from '@/store/modules/account/index';
import partners from '@/store/modules/partners/index';
import dealers from '@/store/modules/account/dealers/index';
import customizer from './modules/customizer';

Vue.use(Vuex);

export default new Vuex.Store({
  mutations,
  actions,
  modules: {
    basket,
    filters,
    models,
    options,
    user,
    common,
    slider,
    guide,
    account,
    partners,
    dealers,
    customizer,
  },
});
